import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../icons/hotcurvesfun.svg'

const ChadHeaderLink = ({ className }) => {
  return (
    <Link
      to="/board"
      style={{ height: '100%', textDecoration: 'blink' }}
      className="logo-header"
    >
      <img
        src={logo}
        alt="logo"
        className={`w-auto max-w-[160px] sm:max-w-[200px] md:max-w-[240px] object-contain ${className}`}
      />
    </Link>
  )
}

export default ChadHeaderLink
